import { Spinner } from "@telegram-apps/telegram-ui";

export default function () {
    return (
        <div className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]">
            <Spinner size="m" />
        </div>
    );
}
